module.exports = __webpack_public_path__ + "static/img/about16.023abcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about16.png
// module id = qyBk
// module chunks = 1